import axios from 'axios';
import { API_BASE_URL } from 'configs/AppConfig';
import { signOutSuccess } from 'store/slices/authSlice';
import store from '../store';
import { AUTH_TOKEN } from 'constants/AuthConstant';
import { notification } from 'antd';

const unauthorizedCode = [401]

const service = axios.create({
  baseURL: API_BASE_URL,
  timeout: 60000
})

// Config
const TOKEN_PAYLOAD_KEY = 'Authorization'

// API Request interceptor
service.interceptors.request.use(config => {
	const jwtToken = localStorage.getItem(AUTH_TOKEN) || null;
	
	if (jwtToken) {
		config.headers[TOKEN_PAYLOAD_KEY] = 'Bearer ' + jwtToken
	}
  	return config
}, error => {
	// Do something with request error here
	notification.error({
		message: 'Error'
	})
	Promise.reject(error)
})

const obterTraceId = (response) => {
	if (!response || !response.headers) return null
	return response.headers['x-trace-id'] || response.headers['X-Trace-Id'] || null
}

// API respone interceptor
service.interceptors.response.use( (response) => {
	return response.data
}, (error) => {

	let notificationParam = {
		message: ''
	}

	const traceId = obterTraceId(error.response)

	if (!error.response) {
		notificationParam.message = 'Falha de conexão'
		notification.error(notificationParam)
		return Promise.reject(error)
	}

	// Remove token and redirect
	if (unauthorizedCode.includes(error.response.status)) {
		notificationParam.message = 'Falha na Autenticação'
		notificationParam.description = 'Por favor, faça seu login'
		localStorage.removeItem(AUTH_TOKEN)

		store.dispatch(signOutSuccess())
	}

	if (error.response.status === 404) {
		notificationParam.message = 'Not Found'
	}

	if (error.response.status === 500) {
		notificationParam.message = 'Ops! Algo deu errado. Contate o administrador'
	}

	if (error.response.status === 508) {
		notificationParam.message = 'Time Out'
	}

	if (error.response.status === 429) {
		notificationParam.message = error?.response?.data?.message || 'Captcha Inválido'
	}

	if (error.response.status === 400) {
		notificationParam.message = error?.response?.data?.message || "Erro interno. Contate o administrador.";
	}

	if (error.response.status === 403) {
		notificationParam.message = error?.response?.data?.message || "Erro interno. Contate o administrador.";
	}

	// Fallback: garante a mensagem do backend para status não tratados acima (ex.: 422)
	if (!notificationParam.message) {
		notificationParam.message = error?.response?.data?.message || "Erro inesperado."
	}

	const isModuloIndisponivel = error?.response?.data?.errorCode === 'INVALID_MODULE'

	if (traceId && !isModuloIndisponivel) {
		const refLine = `Ref: ${traceId}`
		notificationParam.description = notificationParam.description
			? `${notificationParam.description} • ${refLine}`
			: refLine
		console.error(`[trace ${traceId}] ${error.response.status} ${error.config?.method?.toUpperCase()} ${error.config?.url}`)
	}

	if (isModuloIndisponivel) {
		notification.info(notificationParam)
	} else {
		notification.error(notificationParam)
	}

	return Promise.reject(error);
});

export default service